import firebase from '../config/fbConfig';
import {
  MAGIC_LINK_EMAIL_MISMATCH_ERROR_CODE,
  MAGIC_LINK_EXPIRED_ERROR_CODES,
  SupportedAuthProvidersEnum,
} from '../constants/auth';

export const authenticateWithPopup = async (providerId?: SupportedAuthProvidersEnum) => {
  const provider = providerId ? new firebase.auth.OAuthProvider(providerId) : new firebase.auth.GoogleAuthProvider();

  try {
    return await firebase.auth().signInWithPopup(provider);
  } catch (error) {
    return { error };
  }
};

export const getIdToken = (forceRefresh?: boolean) => {
  return firebase.auth().currentUser?.getIdTokenResult(forceRefresh);
};

export const isMagicLinkSignIn = (url: string) => firebase.auth().isSignInWithEmailLink(url);

export const signInWithMagicLink = (email: string, url: string) => firebase.auth().signInWithEmailLink(email, url);

const getFirebaseErrorCode = (error: unknown): string | undefined =>
  typeof error === 'object' && error !== null && 'code' in error
    ? String((error as { code: unknown }).code)
    : undefined;

export const isExpiredMagicLinkError = (error: unknown): boolean => {
  const code = getFirebaseErrorCode(error);
  return !!code && MAGIC_LINK_EXPIRED_ERROR_CODES.includes(code);
};

export const isMagicLinkEmailMismatchError = (error: unknown): boolean =>
  getFirebaseErrorCode(error) === MAGIC_LINK_EMAIL_MISMATCH_ERROR_CODE;
